import { render, staticRenderFns } from "./eBusiness.vue?vue&type=template&id=6bccd64c&scoped=true&"
import script from "./eBusiness.vue?vue&type=script&lang=js&"
export * from "./eBusiness.vue?vue&type=script&lang=js&"
import style0 from "./eBusiness.vue?vue&type=style&index=0&id=6bccd64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bccd64c",
  null
  
)

export default component.exports